__webpack_require__.b = document.baseURI || self.location.href;

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"wp-runtime": 0,
	"app_assets_modules_react-partials_repos-overview_components_OverviewContent_module_css-app_as-2f8a17": 0,
	"lazy-react-partial-actions-custom-images-retention-policy": 0,
	"lazy-react-partial-actions-policies": 0,
	"lazy-react-partial-actions-survey": 0,
	"lazy-react-partial-automated-review-comment": 0,
	"lazy-react-partial-browser-geo-location": 0,
	"lazy-react-partial-codespaces-survey": 0,
	"lazy-react-partial-consent-experience": 0,
	"lazy-react-partial-copilot-assisted-review-upsell": 0,
	"lazy-react-partial-copilot-code-review-feedback": 0,
	"lazy-react-partial-copilot-code-review-upsell": 0,
	"lazy-react-partial-copilot-content-exclusion": 0,
	"lazy-react-partial-copilot-survey": 0,
	"lazy-react-partial-custom-copilot-code-review-comment": 0,
	"lazy-react-partial-custom-signup-content-manager": 0,
	"lazy-react-partial-date-picker-partial": 0,
	"lazy-react-partial-delete-configuration-dialog": 0,
	"lazy-react-partial-education-schools-auto-complete": 0,
	"lazy-react-partial-email-subscription-form": 0,
	"lazy-react-partial-external-group-team-mismatch-widget": 0,
	"lazy-react-partial-growth-banner-partial": 0,
	"lazy-react-partial-network-configurations-select-panel": 0,
	"lazy-react-partial-new-agent-task-button": 0,
	"lazy-react-partial-react-partial-anchor-example": 0,
	"lazy-react-partial-react-sandbox-sidenav": 0,
	"lazy-react-partial-ref-selector-partial": 0,
	"lazy-react-partial-search-results": 0,
	"lazy-react-partial-security-center-pagination": 0,
	"lazy-react-partial-sponsors-dashboard-your-sponsors": 0,
	"lazy-react-partial-sponsors-newsletters": 0,
	"lazy-react-partial-trade-screening-status-banner": 0,
	"lazy-react-partial-enterprise-team": 0,
	"packages_action-bar_src_OverflowMenu_module_css-packages_action-bar_src_VisibleAndOverflowCon-61352d": 0,
	"packages_action-bar_src_OverflowMenu_module_css-packages_action-bar_src_VisibleAndOverflowCon-861856": 0,
	"lazy-react-partial-dependabot-repository-access-org-settings": 0,
	"packages_control-group_components_ControlGroupContainer_module_css-packages_control-group_com-056d8d": 0,
	"packages_filter-picker_TokenizedQuery_module_css-packages_filter-picker_components_PickerDial-12c27b": 0,
	"packages_filter-picker_TokenizedQuery_module_css-packages_filter-picker_components_PickerDial-8e7629": 0,
	"packages_licensing-common_components_CopilotUsageSummary_module_css-packages_licensing-common-89776c": 0,
	"packages_action-bar_src_OverflowMenu_module_css-packages_action-bar_src_VisibleAndOverflowCon-b3dff3": 0
};

__webpack_require__.f.j = (chunkId, promises) => {
		// JSONP chunk loading for javascript
		var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
		if(installedChunkData !== 0) { // 0 means "already installed".

			// a Promise means "currently loading".
			if(installedChunkData) {
				promises.push(installedChunkData[2]);
			} else {
				if(!/^(lazy\-react\-partial\-(a(ctions\-(custom\-images\-retention\-policy|policies|secrets\-variables\-list|survey)|utomated\-review\-comment(|\-actions))|c(o(de(\-scanning\-(alert\-dismissal|development\-section)|spaces\-(business\-enablement|organization\-ownership\-setting|policy\-name\-input|survey))|pilot\-(a(cti(ons\-chat\-button|vation\-progress\-bar)|ssisted\-review\-upsell)|co(de\-(guideline(\-review\-comment|s\-playground)|review\-(feedback|upsell)|chat)|ntent\-exclusion)|su(mmary\-banner|rvey)|(byok\-enterprise|model)\-settings|markdown\-toolbar\-button|progress\-indicator|quota\-usage|user\-checklist)|nfigure\-mcp\-server\-partial|nsent\-experience)|reate\-branch\-(button|dialog)|ustom\-(signup\-content(|\-manager)|copilot\-code\-review\-comment))|d(ate\-(picker\-partial|time\-settings)|e(lete\-configuration\-dialog|mo\-repo\-tour|pendabot\-repository\-access\-org\-settings))|e(nterprise\-team(|s\-table\-view)|ducation\-schools\-auto\-complete|mail\-subscription\-form|xternal\-group\-team\-mismatch\-widget)|g(lobal\-(c(opilot|reate)\-menu|(sso\-bann|user\-nav\-draw)er)|etting\-started\-todo\-list|rowth\-banner\-partial)|in(te(gration\-permission\-selector|rnal\-api\-insights)|sights\-sidenav\-partial)|l(icensi(ng\-(enterprise\-((|server\-)overview|cloud\-details)|(advanced\-security|copilot)\-overview)|fy\-licenses)|aunch\-code)|m(et(adata\-suggestion\-staffbar\-component|ered\-enterprise\-server\-licenses)|arketing\-navigation)|n(etwork\-configurations\-select\-panel|ew\-agent\-task\-button|otifications\-subscriptions\-menu|ux\-dashboard\-refresh)|re(act\-(partial\-(|anchor\-)example|sandbox\-sidenav)|f\-selector\-partial|pository\-runners)|s(e(c(urity\-(center\-paginati|overview\-export\-butt)on|ret\-scanning\-bypass\-reviewers\-dialog)|arch\-results|ssions\-auth\-header)|ponsor(s\-((dashboard\-your\-sponso|newslette)rs|explore\-filter|meet\-the\-team\-list|signup)|\-org\-dependencies)|(hared\-dismiss|ingle\-sign\-on\-dropdown\-parti)al|so\-orgs\-settings\-list)|browser\-geo\-location|keyboard\-shortcuts\-dialog|product\-announcement|pull\-requests\-processing\-indicator|teams\-settings\-page|trade\-screening\-status\-banner|webcam\-upload|your\-sponsorships)|packages_(action\-bar_src_OverflowMenu_module_css\-packages_action\-bar_src_VisibleAndOverflowCon\-(61352d|861856|b3dff3)|f(ilter\-picker_TokenizedQuery_module_css\-packages_filter\-picker_components_PickerDial\-(12c27b|8e7629)|lash\-error_FlashError_module_css\-packages_text\-expander_TextExpander_module_css\-pac\-a35192)|control\-group_components_ControlGroupContainer_module_css\-packages_control\-group_com\-056d8d|licensing\-common_components_CopilotUsageSummary_module_css\-packages_licensing\-common\-89776c)|app_assets_modules_react\-partials_repos\-overview_components_OverviewContent_module_css\-app_as\-2f8a17|wp\-runtime)$/.test(chunkId)) {
					// setup Promise in chunk cache
					var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
					promises.push(installedChunkData[2] = promise);

					// start chunk loading
					var url = __webpack_require__.p + __webpack_require__.u(chunkId);
					// create error before stack unwound to get useful stacktrace later
					var error = new Error();
					var loadingEnded = (event) => {
						if(__webpack_require__.o(installedChunks, chunkId)) {
							installedChunkData = installedChunks[chunkId];
							if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
							if(installedChunkData) {
								var errorType = event && (event.type === 'load' ? 'missing' : event.type);
								var realSrc = event && event.target && event.target.src;
								error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
								error.name = 'ChunkLoadError';
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							}
						}
					};
					__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
				} else installedChunks[chunkId] = 0;
			}
		}
};

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = globalThis["webpackChunk_github_ui_github_ui"] = globalThis["webpackChunk_github_ui_github_ui"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));